<div class="crew-modal-overlay" *ngIf="room" (click)="close.emit()">
  <div class="crew-modal" (click)="$event.stopPropagation()">

    <div class="crew-modal-header">
      <pss-sprite *ngIf="roomSpriteId(room.roomDesignId)" class="room-modal-sprite" [spriteId]="roomSpriteId(room.roomDesignId)"></pss-sprite>
      <span class="room-type-badge room-type-{{ roomType(room.roomDesignId) | lowercase }}">{{ roomType(room.roomDesignId) || 'Room' }}</span>
      <span class="crew-modal-name">{{ roomName(room.roomDesignId) }}</span>
      <span style="font-size:0.65rem; color:var(--text-dim); margin-left:auto; margin-right:0.5rem;">R{{ room.row }}·C{{ room.col }}</span>
      <button class="crew-modal-close" (click)="close.emit()">✕</button>
    </div>

    <div class="crew-modal-body">

      <ng-container *ngIf="selectedRoomFireRate !== null || roomHasStatBoost">
        <div class="crew-modal-section-title">Combat Stats</div>
        <div class="room-combat-stats">

          <div class="room-stat-row" *ngIf="availableAmmo.length > 0">
            <span class="room-stat-label">Ammo</span>
            <span class="room-stat-val">
              <select [ngModel]="selectedAmmoId" (ngModelChange)="selectedAmmoIdChange.emit($event)" class="ammo-select">
                <option [ngValue]="null">Default</option>
                <option *ngFor="let a of availableAmmo" [ngValue]="a.id">{{ a.name }}</option>
              </select>
            </span>
          </div>

          <ng-container *ngIf="selectedRoomFireRate !== null">
            <div class="room-stat-row">
              <span class="room-stat-label">Fire Rate</span>
              <span class="room-stat-val">{{ roomStatFmt(selectedRoomFireRate) }} s</span>
            </div>
            <div class="room-stat-row" *ngIf="selectedRoomMinDps !== null || selectedRoomMaxDps !== null">
              <span class="room-stat-label">DPS</span>
              <span class="room-stat-val">
                <ng-container *ngIf="selectedRoomMinDps !== null && selectedRoomMaxDps !== null && selectedRoomMinDps !== selectedRoomMaxDps">
                  {{ roomStatFmt(selectedRoomMinDps) }} – {{ roomStatFmt(selectedRoomMaxDps) }}
                </ng-container>
                <ng-container *ngIf="selectedRoomMaxDps !== null && (selectedRoomMinDps === null || selectedRoomMinDps === selectedRoomMaxDps)">
                  {{ roomStatFmt(selectedRoomMaxDps) }}
                </ng-container>
              </span>
            </div>
            <div class="room-stat-row room-stat-dim" *ngIf="selectedRoomAdjacentAB">
              <span class="room-stat-label">AB Room</span>
              <span class="room-stat-val">+{{ selectedRoomAbBoost }}%</span>
            </div>
          </ng-container>

          <div class="room-stat-row room-stat-dim">
            <span class="room-stat-label">{{ selectedRoomStatLabel }} Boost</span>
            <span class="room-stat-val">+{{ selectedRoomCrewBoost | number:'1.1-1' }}</span>
          </div>
          <ng-container *ngFor="let c of selectedRoomCrew">
            <div class="room-stat-row room-stat-crew crew-clickable" (click)="openCrewFlyout(c)">
              <pss-sprite class="crew-avatar" *ngIf="crewSpriteId(c.designId)" [spriteId]="crewSpriteId(c.designId)"></pss-sprite>
              <span class="room-stat-label">{{ crewName(c) }}</span>
              <span class="room-stat-val">{{ selectedRoomStatLabel }} +{{ crewStat(c) }}</span>
            </div>
          </ng-container>

          <app-crew-flyout
            *ngIf="selectedCrewFlyout"
            [crew]="selectedCrewFlyout"
            [characterDesigns]="characterDesigns"
            [itemDesigns]="itemDesigns"
            [inventory]="inventory"
            (close)="selectedCrewFlyout = null">
          </app-crew-flyout>
          <div class="room-stat-row room-stat-dim" *ngIf="selectedRoomCrew.length === 0">
            <span class="room-stat-label" style="font-style:italic">No crew in room</span>
          </div>

        </div>
      </ng-container>

      <div class="crew-modal-section-title" *ngIf="canEditAi">Room AI</div>

      <ng-container *ngIf="canEditAi">
        <app-ai-editor
          [rules]="rules"
          [conditionTypes]="conditionTypes"
          [actionTypes]="actionTypes"
          [itemsByIndex]="aiItems"
          [saving]="roomAiSaving"
          [error]="roomAiError"
          [emptyMessage]="'No AI rules — room will use default behaviour.'"
          [initialConditionId]="initialConditionId"
          [initialActionId]="initialActionId"
          [targetType]="'room'"
          [targetId]="room.roomId"
          [startExpanded]="true"
          [userId]="userId"
          [allianceId]="allianceId"
          [userName]="userName"
          (addRule)="addRule.emit($event)"
          (deleteRule)="deleteRule.emit($event)"
          (moveRule)="moveRule.emit($event)"
          (importRules)="importRules.emit($event)"
          (deleteAllRules)="deleteAllRules.emit()"
          (editRule)="editRule.emit($event)">
        </app-ai-editor>
      </ng-container>

    </div>
  </div>
</div>
